"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uiSchema = {
    type: "VerticalLayout",
    elements: [
        {
            type: "HorizontalLayout",
            elements: [
                {
                    type: "Control",
                    scope: "#/properties/visitDate",
                    options: {
                        format: "date",
                        disableFuture: true,
                    },
                },
                {
                    type: "Control",
                    scope: "#/properties/withVisit",
                    label: "With Visit",
                    options: {
                        format: "radio",
                    },
                },
            ],
        },
        {
            type: "HorizontalLayout",
            elements: [
                {
                    type: "Control",
                    scope: "#/properties/nameOfPersonSpokenTo",
                },
                {
                    type: "Control",
                    scope: "#/properties/informedPhysician",
                    label: "Notified Physician",
                    options: {
                        format: "radio",
                    },
                },
            ],
        },
        { type: "Control", scope: "#/properties/notes" },
    ],
};
exports.default = uiSchema;
